<template>
  <section class="section section--posts-list" id="posts-list">
    <aside class="left-panel">
      <ArrowRight :isContactPanelActive="isContactPanelActive" />
    </aside>
    <main class="main">
      <PostList />
      <img
        @click="scrollToTopOfSection"
        class="arrow-to-top"
        v-if="isMobile"
        src="../../assets/img/arrow.svg"
        title="Przewiń do początku"
        alt="scroll to top"
      />
    </main>
  </section>
</template>

<script>
import { bus } from "../../main";

import ArrowRight from "../ArrowRight";
import PostList from "../PostList";

export default {
  name: "PostsList",
  components: {
    ArrowRight,
    PostList
  },
  props: {
    isContactPanelActive: Boolean,
    isMobile: Boolean
  },
  methods: {
    scrollToTopOfSection() {
      bus.$emit("scrollToNextSection", 1);
    }
  }
};
</script>


<style lang="scss">
#posts-list {
  width: 100%;

  .left-panel {
    position: relative;
  }

  .arrow-right {
    position: fixed;
    bottom: $screen-gutter-left;
    left: 0;
    transition: 0.75s ease;
    transform: translate(-100%, -40%);

    img {
      transition: opacity 0.75s ease;
      opacity: 0;
    }
  }

  .postlist {
    margin-top: 100px;
  }

  .arrow-to-top {
    position: absolute;
    bottom: $screen-gutter-bottom - 20px;
    right: 6%;
    transform-origin: bottom left;
    transform: translate(100%, 0) rotate(-90deg);
  }

  @media (max-width: $tablet) {
    flex-direction: column;
    scroll-behavior: smooth;

    .postlist {
      margin-top: 0;
      padding-right: 50px;
    }
  }
}

#app[data-screen="bottom"] {
  .arrow-right {
    left: calc(100% - #{$main-width} - #{$aside-gutter-right});

    img {
      opacity: 1;
    }
  }
}
</style>